import { useWallet } from "@buidlerlabs/hashgraph-react-wallets";
import { Button, Group, Image, Stack, Text, Indicator } from "@mantine/core";
import { showNotification } from "@mantine/notifications";
import { IconX } from "@tabler/icons";
import { useState } from "react";

export const WalletBtn = ({ wallet, onConnected }) => {
  const [isLoading, setLoading] = useState(false);
  const { isConnected, connect, disconnect } = useWallet(wallet.connector);

  const handleConnect = async () => {
    try {
      setLoading(true);
      await connect();
      onConnected();
    } catch (error) {
      console.error(error);
      showNotification({
        icon: <IconX />,
        autoClose: 4000,
        color: "red",
        title: "Failed.",
        message: "Couldn't connect your wallet. See console for details",
        loading: false
      });
    } finally {
      setLoading(false);
    }
  };

  const handleDisconnect = async () => {
    try {
      setLoading(true);
      await disconnect();
    } catch (error) {
      console.error(error);

      showNotification({
        icon: <IconX />,
        autoClose: 4000,
        color: "red",
        title: "Failed.",
        message: "Couldn't disconnect your wallet. See console for details",
        loading: false
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Group position="apart">
      <Group>
        <Image width={40} height={40} src={wallet.icon} alt="Wallet icon" />{" "}
        <Stack spacing={0}>
          <Text>{wallet.name}</Text>
          {isConnected && (
            <Group spacing="xs">
              <Indicator color="green" />
              <Text size="xs" color="dimmed">
                Connected
              </Text>
            </Group>
          )}
        </Stack>
      </Group>
      {isConnected ? (
        <Button variant="outline" onClick={handleDisconnect} color="red">
          Disconnect
        </Button>
      ) : (
        <Button onClick={handleConnect} loading={isLoading}>
          Connect
        </Button>
      )}
    </Group>
  );
};
